import { createHash } from 'crypto';

const getContentHash = (content: Buffer) => {
  return createHash('sha256').update(content).digest('hex').slice(0, 8);
};

export { getContentHash };
